import { render, staticRenderFns } from "./WelcomeRoom.vue?vue&type=template&id=68e004c4&scoped=true"
import script from "./WelcomeRoom.vue?vue&type=script&lang=js"
export * from "./WelcomeRoom.vue?vue&type=script&lang=js"
import style0 from "./WelcomeRoom.vue?vue&type=style&index=0&id=68e004c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e004c4",
  null
  
)

export default component.exports